module.exports = __webpack_public_path__ + "static/media/arrowDown.feb8b78b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/UI.MenuNew/Icon/arrowDown.svg
// module id = 7081
// module chunks = 0